import { Component, OnInit } from '@angular/core';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { CommonService } from 'src/app/services/common.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';

@Component({
  standalone: false,
  selector: 'app-disburse-member-card-preview',
  templateUrl: './disburse-member-card-preview.component.html',
  styleUrls: ['./disburse-member-card-preview.component.scss']
})
export class DisburseMemberCardPreviewComponent implements OnInit {

  success: boolean;
  templateUrl: any;
  baseUrl;

  tableHeaders: any[] = [];
  tableBody: any = [];
  guestList: any;
  validationError: any[];
  isValid: any[];
  isValidtRow: any[];
  totalInValidRows: number;
  totalValidRows: number;
  validationEr: boolean;
  errDate: any;
  selectAllMemberCard: boolean = false;
  hideShowDataTable: any;
  allNewMemberIdList: any = [];
  data: any;
  url: string;
  assingedRfidNumber = '';
  token: string;
  allocatedCardCountDetails: any;
  errorClass: string;

  constructor(
    private router: Router,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private apiService: ApiService,
    private appStateSrv: AppStateProvider,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {

    this.data = this.dataService.getExcelData();
    console.log(this.data);
    if (this.data != null) {
      // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
    }

    let tenantId = localStorage.getItem("tenantId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/Company/GetMemberCardListByTenantId?tenantId=${tenantId}`;
    console.log(this.baseUrl);

    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });

    this.token = 'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
  }

  reprepareData(tb, th) {
    var finalB = []
    tb.forEach(res => {
      let bdata = {};
      res.forEach((tb, bodyIndex) => {
        //console.log(body);
        th.forEach((head, headIndex) => {
          // console.log(head)
          if (bodyIndex == headIndex) {
            bdata[head] = tb
          }
        })
      })
      // console.log(bdata);
      finalB.push(bdata)
    })
    return finalB
  }

  removeArraysContainingBlank(arr) {
    return arr.filter(subArr => subArr.every(elem => elem.trim() !== ''));
  }

  prepareTableData(tableData) {

    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];

    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));

    this.tableHeaders = [...new Set(sampleheaders)];

    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp);
      console.log(this.tableBody);
      this.guestList = this.tableBody;
      console.log(this.guestList);
    }
  }

  removeRecordsWithMissingFields(arr) {
    return arr.filter(obj => {
      return obj.hasOwnProperty('Card Serial Number') &&
        obj.hasOwnProperty('Access Card Number') &&
        obj.hasOwnProperty('Tenant Name');
    });
  }

  processApiResponse(data) {
    console.log(data);

    let finalData = this.removeRecordsWithMissingFields(data);
    console.log(finalData);

    // let checkDuplicate = this.hasDuplicateAndSpecialCharacters(finalData);
    // console.log(checkDuplicate);
    // if (checkDuplicate === true) {
    //   this.validationEr = true;
    //   this.appStateSrv.showToast(
    //     'There is duplicate data or your data may contain special chatacters. Please modify your data before uploading.'
    //   );
    //   // return;
    // } else {
    //   this.validationEr = false;
    // }

    if (finalData.length > 2000) {
      this.appStateSrv.showToast('Member Card ID cannot exceed 2000');
      return;
    }

    this.bulkInviteValidation(finalData);

    if (finalData != null) {

      this.validationError = [];
      this.isValid = [];
      this.isValidtRow = [];
      finalData.map(result => {
        this.validationError.push(result.validationIssues)
        this.isValid.push(result.isValid)
        this.isValidtRow.push(result.isValidRow)
      });
      this.prepareTableData(finalData)
      this.totalInValidRows = 0;
      this.totalValidRows = 0;
      for (let rowEmp of this.isValidtRow) {
        if (rowEmp == false)
          this.totalInValidRows++;
        else
          this.totalValidRows++;
      }
    }
  }

  handleFileSelect(evt) {
    this.tableHeaders = [];
    console.log(evt);
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        console.log(data);
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        // this.router.navigate(['/bulk-upload-preview/']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });

    setTimeout(() => {
      this.data = this.dataService.getExcelData();
      if (this.data != null) {
        // this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
        this.processApiResponse(JSON.parse(this.data).map(obj => ({ ...obj })));
      }
    }, 10);

  }

  updateTable(data) {
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
  }

  deleteSelected(inviteData, i) {
    console.log(inviteData)
    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      this.tableBody.splice(i, 1);
    }
    setTimeout(() => {
      this.checkIfSelected(i + '__th');
    }, 10);
    this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders))
    // this.bulkInviteValidation(this.tableBody)
  }

  editSelected(from, to, i, type) {

    console.log(i);

    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }

      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);

      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);
        }
        _t.push(true, true, true);
        this.tableBody.splice(i, 1, _t);
        setTimeout(() => {
          this.checkIfSelected(i + '__th');
        }, 10);
        this.processApiResponse(this.reprepareData(this.tableBody, this.tableHeaders));
      }
    }
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : '';
  }

  validateArray(arr) {
    // Define an object to store encountered properties
    var encounteredProperties = {};

    // Define an array to store valid items
    var validItems = [];

    // Iterate through the array
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      var isValid = true;

      // Check each property for existence and non-empty value
      for (var key in item) {
        if (!item[key]) {
          isValid = false;
          break; // Break the loop if any property is missing or empty
        }
        encounteredProperties[key] = true; // Store encountered properties
      }

      // If the item is valid, add it to the validItems array
      if (isValid) {
        validItems.push(item);
      }
    }

    // Check if all properties are encountered
    var allPropertiesEncountered = Object.keys(arr[0]).every(function (key) {
      return encounteredProperties[key];
    });

    // If all properties are encountered, return the validItems array, otherwise return an empty array
    return allPropertiesEncountered ? validItems : [];
  }

  removeInvalidObjects(arr) {
    // Get keys of the first object
    const keys = Object.keys(arr[0]);

    // Filter out objects with missing or extra keys
    return arr.filter(obj => {
      return Object.keys(obj).every(key => keys.includes(key));
    });
  }

  bulkInviteValidation(data) {
    console.log(JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")));

    // let newData = JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, ""));
    // let finalData = this.removeRecordsWithMissingFields(newData);

    this.validationEr = false;

    // JSON.parse(JSON.stringify(data).replace(/\s/g, "")).forEach((res, i) => {
    // });

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {

      console.log(res);

      if (res.AccessCardNumber == undefined || res.AccessCardNumber.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.CardSerialNumber == undefined || res.CardSerialNumber.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
      if (res.TenantName == undefined || res.TenantName.length == 0) {
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      }
    });

    // let checkDuplicate = this.hasDuplicateAndSpecialCharacters(data);
    // console.log(checkDuplicate);
    // if (checkDuplicate === true) {
    //   this.validationEr = true;
    //   this.appStateSrv.showToast(
    //     'There is duplicate data or your data may contain special chatacters. Please modify your data before uploading.'
    //   );
    // } else {
    //   this.validationEr = false;
    // }

    // var specialCharRegex = /[^a-zA-Z0-9-]/;
    // let checkDuplicate = this.hasDuplicateAndSpecialCharacters(data);
    // console.log(checkDuplicate);
    // if (checkDuplicate === true) {
    //   JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {
    //     if (specialCharRegex.test(res.AccessCardNumber) || specialCharRegex.test(res.CardSerialNumber)) {
    //       data[i].isValid = false
    //       data[i].isValidRow = false;
    //       data[i].validationIssues = false;
    //       this.validationEr = true;
    //     } else {
    //       data[i].isValid = true;
    //       data[i].isValidRow = true;
    //       data[i].validationIssues = true;
    //     }
    //   });
    //   this.appStateSrv.showToast(
    //     'There is duplicate data or your data may contain special chatacters. Please modify your data before uploading.'
    //   );
    // } else {
    //   this.validationEr = false;
    // }
// let checkDuplicate = this.hasDuplicateAndSpecialCharacters(data);
    // console.log(checkDuplicate);
    let specialCharRegex = /[^a-zA-Z0-9-]/;
    let encountered = {};
    let encountered2 = {};

    JSON.parse(JSON.stringify(data).replace(/\s/g, "").replace(/\./g, "")).forEach((res, i) => {
      console.log(res.AccessCardNumber);
      let item = data[i];
      let slNo = res.CardSerialNumber;
      let rfidCardNumber = res.AccessCardNumber;
      // let combination = slNo + '|' + rfidCardNumber;
      let combination = slNo + '|' + '0';
      let combination2 = rfidCardNumber + '|' + '0';

      // If the combination is already encountered, return true (duplicate found)
      if (((encountered[combination]) || (encountered2[combination2]))) {
        this.errorClass = 'error-row';
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      } else if ((specialCharRegex.test(res.AccessCardNumber) || specialCharRegex.test(res.CardSerialNumber))) {
        this.errorClass = 'error-row';
        data[i].isValid = false
        data[i].isValidRow = false;
        data[i].validationIssues = false;
        this.validationEr = true;
      } else {
        this.errorClass = '';
        encountered[combination] = true;
        encountered2[combination2] = true;
        data[i].isValid = true;
        data[i].isValidRow = true;
        data[i].validationIssues = true;
        // this.validationEr = false;
      }
      if (this.validationEr == true) {
        this.appStateSrv.showToast(
          'There is duplicate data or your data may contain special chatacters. Please modify your data before uploading.'
        );
      }
    });

  }

  selectAllHandler() {
    if (this.selectAllMemberCard) { }
  }

  selectedGuest(guestData, index) {

  }
  deleteAllInvites() {
    if (this.selectAllMemberCard) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  send() {

    this.allNewMemberIdList = [];

    for (let i = 0; i < this.guestList.length; i++) {

      const allMemberIdData =
      {
        SerialNumber: this.guestList[i][0],
        RFIDCardNumber: this.guestList[i][1],
        TenantName: this.guestList[i][2],
      }
      this.allNewMemberIdList.push(allMemberIdData);
    }

    // this.url = APIs.tenantWiseCardBulkUpload;

    // const paramobj = {
    //   // tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
    //   IsActive: "true",
    //   CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
    //   TenantId: localStorage.getItem("tenantId") ?? 1,
    //   tenantMemberCardDetails: this.allNewMemberIdList
    // };
    // this.apiService.post(this.url, paramobj).subscribe(
    //   (response: any) => {
    //     var r = response.data;
    //     this.router.navigate(['/companies/companies-list']);
    //   },
    //   (err) => console.log('error', err)
    // );


    this.url = APIs.tenantAssignedMemberCardForTenant;

    const paramobj = {
      isActive: "true",
      createdBy: localStorage.getItem(AppConstant.localStorage.claId),
      tenantMemberCardDetails: this.allNewMemberIdList,
      parkId: localStorage.getItem("parkId") ?? 1,
    };

    this.apiService.post(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        this.router.navigate(['/disburse-member-card']);
      },
      (err) => console.log('error', err)
    );
  }

  cancelTable() {
    this.tableHeaders = [];
    this.router.navigate(['/disburse-member-card']);
    //this.tableHeaders = [];
    //window.location.reload();
  }

  saveRfidValue() {

    console.log(this.assingedRfidNumber);

    this.url = APIs.tenantAssignedMemberCardForTenant;

    const paramobj = {
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      // IsActive: "true",
      NumberOfCard: this.assingedRfidNumber,
      CreatedBy: localStorage.getItem(AppConstant.localStorage.claId),
    };

    this.apiService.post(this.url, paramobj).subscribe(
      (response: any) => {
        var r = response.data;
        // this.router.navigate(['/companies/companies-list']);
      },
      (err) => console.log('error', err)
    );

  }

  tenantMemberAllocatedCard() {
    let tenantId = localStorage.getItem("tenantId") ?? 1;
    this.url = APIs.tenantMemebrAllocatedCardCount + '/' + tenantId;
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        console.log(response);
        this.allocatedCardCountDetails = response;
      },
      (err) => console.log('error', err)
    );
  }

  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      // this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj, validationIssues: true, isValid: true, isValidRow: true })));
      this.processApiResponse(JSON.parse(data).map(obj => ({ ...obj })));
    }).catch(err => {
    });
  }

  hasDuplicateAndSpecialCharacters(arr) {
    var encountered = {}; // Object to store encountered combinations

    // Regular expression to match special characters except '-'
    var specialCharRegex = /[^a-zA-Z0-9-]/;

    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      var slNo = item['Card Serial Number'];
      var rfidCardNumber = item['Access Card Number'];
      var combination = slNo + '|' + rfidCardNumber;

      // If the combination is already encountered, return true (duplicate found)
      if (encountered[combination]) {
        return true;
      } else {
        // Mark the combination as encountered
        encountered[combination] = true;
      }

      // Check if 'Sl No' and 'RFID Card Number' contain any special characters except '-'
      if (specialCharRegex.test(slNo) || specialCharRegex.test(rfidCardNumber)) {
        return true; // Return true if any special character other than '-' is found
      }
    }

    // Return false if no duplicates or special characters found
    return false;
  }

}
